import React from 'react';

/**
 * AdminViewingBanner component to show when admin is viewing another user
 */
const AdminViewingBanner = ({ selectedUser, onReturn }) => {
  return (
    <div className="admin-viewing-banner">
      <span className="banner-icon">👁️</span>
      Viewing picks for: {selectedUser?.display_name || selectedUser?.username || 'User'}
      <button onClick={onReturn} className="return-to-own-picks">
        Return to My Picks
      </button>
    </div>
  );
};

export default AdminViewingBanner;
